module.exports = __webpack_public_path__ + "static/media/image (23).1e228aa4.jpg";